import React, { useEffect, useState } from 'react';
import { History } from 'lucide-react';
import apiService from '../services/api';
import { ReferralAuditLogEntry } from '../types';

const ACTION_LABEL: Record<string, string> = {
  activated: 'Program diaktifkan',
  rejected: 'Referral ditolak',
  refund_cancelled: 'Dibatalkan karena refund',
  code_corrected: 'Kode referral dikoreksi',
  points_adjusted: 'Poin disesuaikan',
};

/**
 * Jejak tindakan admin pada seorang Referrer.
 *
 * Ditampilkan sebagai urutan kejadian, bukan tabel yang bisa disortir: yang
 * dicari saat ada sengketa selalu "apa saja yang terjadi pada orang ini, oleh
 * siapa, dalam urutan apa".
 */
const ReferralAuditLogPanel: React.FC<{ affiliateId: string }> = ({ affiliateId }) => {
  const [entries, setEntries] = useState<ReferralAuditLogEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    apiService
      .getReferralAuditLog(affiliateId)
      .then((res) => { if (!cancelled) setEntries(res.data ?? []); })
      .catch(() => { if (!cancelled) setEntries([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [affiliateId]);

  return (
    <div className="bg-white shadow rounded-lg">
      <div className="px-4 py-5 sm:px-6 flex items-center gap-2">
        <History className="h-5 w-5 text-gray-400" />
        <h3 className="text-lg leading-6 font-medium text-gray-900">Log Audit</h3>
      </div>
      <div className="border-t border-gray-200 px-4 py-4">
        {loading ? (
          <p className="text-sm text-gray-500">Memuat...</p>
        ) : entries.length === 0 ? (
          <p className="text-sm text-gray-500">Belum ada tindakan admin yang tercatat.</p>
        ) : (
          <ol className="space-y-3">
            {entries.map((entry) => (
              <li key={entry.id} className="border-l-2 border-gray-200 pl-3">
                <div className="text-sm font-medium text-gray-900">
                  {ACTION_LABEL[entry.action] ?? entry.action}
                </div>
                <div className="text-xs text-gray-500">
                  {new Date(entry.createdAt).toLocaleString('id-ID')}
                  {entry.performedByName && ` — ${entry.performedByName}`}
                </div>
                {entry.reason && (
                  <div className="text-xs text-gray-700 mt-0.5">{entry.reason}</div>
                )}
              </li>
            ))}
          </ol>
        )}
      </div>
    </div>
  );
};

export default ReferralAuditLogPanel;
